import styled from "styled-components";
import { styleSizes } from "constants/styleSizes";

export const CouponContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;

  @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
    margin-bottom: 60px;
  }
  .couponInput {
    flex: 1 1 auto;
    min-width: 0;
    margin-bottom: 0;
  }
  

  .applyCouponButton {
    flex: 0 0 88px;
    margin-top: 0;
  }
`;

// export const CouponContainer = styled.div`
//   /* position: absolute;
//   bottom: -130px;
//   left: 0; */
//   width: 100%;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   column-gap: 10px;
//   @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
//     position: relative;
//     bottom: auto;
//     margin-top: 32px;
//   }
//   label {
//     color: ${colors.almostBlack};
//     @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
//       font-size: 14px;
//     }
//   }

//   .applyCouponButton {
//     margin-top: 6px;
//   }
// `;